import SendEmailWindow from './SendEmailWindow';

export default SendEmailWindow;